export default "__VITE_ASSET__Jc0S85ZX__"